<template>
  <div id="app">
  <v-app id="inspire">
    <v-app-bar
      app
      color="dark"
      dark
    >
    <v-toolbar-title>Graph Layout Labelling</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container
        fluid
        20
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="dark"
                dark
                flat
              >
                <v-toolbar-title>Login Form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Username"
                    name="Login"
                    v-model="username"
                    type="text"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <router-link to="/create_user" tag="button">
                  <v-btn color="dark">Create New User</v-btn>
                </router-link>
                <v-spacer></v-spacer>
                <v-btn color="dark" @click="login_user">Login</v-btn>
                <div v-if=dialog>
                    <v-dialog 
                        v-model="dialog"
                        max-width="290">                    
                    <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      Error
                    </v-card-title>
                    <v-card-text class= "text-md-body-1">{{error}}</v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="dark"
                        text
                        @click="dialog = false">
                        OK
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                </div>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    
  </v-app>
</div>
</template>

<script>
import config from '@/config';

export default {
  name: 'Login',
  title: 'Login Page',
 data() {
    return{
      username: null,
      error: null,
      dialog: false
    }
    },
  methods:{
    login_user: function (){
      if(!this.username){
        this.error = "Please enter an username."
        this.dialog = true
      }else{
        fetch(`${config.API_BASE_URL}/check_user/${this.username}/`,{
            method: "GET",
            headers:{
              "Content-Type": "application/json"
            },
        })
        .then(resp => {
          if (resp.status === 400){
            this.error = "The user name does not exist. Please enter another one."
            this.dialog = true
            return resp.json()
          }else{
            fetch(`${config.API_BASE_URL}/next_graph/${this.username}/`,{
            method: "GET",
            headers:{
              "Content-Type": "application/json"
            },
            })
            .then(resp => {
              if (resp.status === 400){
                this.error = "You have labeled all the graphs."
                this.dialog = true}
              return resp.json()
            })
            .then(data => {
              // Go directly to question labelling
              this.$router.push({path: '/question-labelling/' + data.user_id + "/" + this.username + "/" + data.graph_id});
            })
        }
        })
        .catch(err =>{
          console.log(err)
        })
      }
    }
  }
}

</script>
